import { useQuery } from 'react-query';

import { taskApi } from 'src/Services/API';

const useFetchTasks = (assetId: string) => {
  return useQuery(['tasks', assetId], () => taskApi.findAll(assetId), {
    enabled: !!assetId,
  });
};

export default useFetchTasks;
